import { DownloadFile, enqueueSnackbar, UploadFile } from 'actions';

import {
	// ImportFileRequest,
	GetAlgorithmsCitiesRequest,
	GetAlgorithmsDatesRequest,
	RunOvershootingByCoordinatesRequest,
	RunOvershootingByFileRequest
} from '../requests/AlgorithmsRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const GET_ALGORITHMS_CITIES = 'GET_ALGORITHMS_CITIES';
export const GET_ALGORITHMS_DATES = 'GET_ALGORITHMS_DATES';
export const RUN_ALGORITHM_OVERSHOOTING = 'RUN_ALGORITHM_OVERSHOOTING';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onGetAlgorithmsCities = (value) => ({
	type: GET_ALGORITHMS_CITIES,
	cities: value
});

const onGetAlgorithmsDates = (value) => ({
	type: GET_ALGORITHMS_DATES,
	dates: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const GetAlgorithmsCities = (userId) => async (dispatch) => {
	await GetAlgorithmsCitiesRequest(userId).then(response => {
		dispatch(onGetAlgorithmsCities(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetAlgorithmsDates = (city) => async (dispatch) => {
	await GetAlgorithmsDatesRequest(city).then(response => {
		dispatch(onGetAlgorithmsDates(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const RunOvershootingByCoordinates = (
	userId, city, date, points, tech2g, tech3g, tech4g,
	osParameters2g, osParameters3g, osParameters4g
) => async (dispatch) => {
	await RunOvershootingByCoordinatesRequest(
		userId, city, date, points, tech2g, tech3g, tech4g,
		osParameters2g, osParameters3g, osParameters4g
	).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const RunOvershootingByFile = (
	userId, city, date, filePath, tech2g, tech3g, tech4g,
	osParameters2g, osParameters3g, osParameters4g
) => async (dispatch) => {
	await RunOvershootingByFileRequest(userId, city, date, filePath, tech2g, tech3g, tech4g,
		osParameters2g, osParameters3g, osParameters4g
	).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const UploadFileThenRunOvershooting = (city, date, file, tech2g, tech3g, tech4g, userId) => async (dispatch) => {
	await UploadFile(file).then(response => {
		dispatch(RunOvershootingByFile(city, date, response.data, tech2g, tech3g, tech4g, userId));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
